import axios, { AxiosError } from "axios"
import { LIST_PATH, IDENTIFICATION_TYPE_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getIdentificationTypesService = async () => {
  try {
    const result = await instance.get(IDENTIFICATION_TYPE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createIdentificationTypeService = async (
  identificationType: any
) => {
  try {
    const result = await instance.post(
      IDENTIFICATION_TYPE_PATH,
      identificationType
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteIdentificationTypeService = async (id: any) => {
  try {
    const result = await instance.delete(IDENTIFICATION_TYPE_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editIdentificationTypeService = async (
  id: number,
  identificationType: any
) => {
  try {
    const result = await instance.put(
      IDENTIFICATION_TYPE_PATH + `/${id}`,
      identificationType
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
